import React from 'react';
import {Container} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
    faTriangleExclamation, faCircleCheck, faArrowRightLong
} from '@fortawesome/free-solid-svg-icons';

const pairs = [
    {
        accent: '#2f5597',
        challengeTitle: 'Knowledge that kept breaking',
        challengeDesc: 'Ontologies worked for one domain view, then shattered when a second was added. A compliance process step isn\'t an obligation or a prohibition. The model had no box for it.',
        breakthroughTitle: 'We stopped defining. We started learning.',
        breakthroughDesc: 'We trained the model to discover semantic structure directly from language. It learns that "shall report all transactions" and "clinicians should offer CBT" share the same shape - someone must do something, with a degree of authority. First domain expensive. Second cheaper. Third mostly automatic.'
    },
    {
        accent: '#7030a0',
        challengeTitle: 'LLMs couldn\'t be trusted',
        challengeDesc: 'We needed AI that could reason in regulated environments - finance, legal, healthcare, compliance. LLMs give different answers every time. They hallucinate. They can\'t show their working.',
        breakthroughTitle: 'We built a Consistentlanguage model.',
        breakthroughDesc: 'Knowledge encoded as graphs and embeddings, not compressed into parametric weights. Same question, same answer, every time. Every output traces back to exactly which document, which passage, which rule drove it. Patent pending. This is Nebulyx Cognition.'
    },
    {
        accent: '#502070',
        challengeTitle: 'Agents went rogue',
        challengeDesc: 'AI agents are powerful - they can discover, reason, and act autonomously. But autonomy without governance is a liability. Unbounded agents hallucinate outside their knowledge and make decisions without audit trails.',
        breakthroughTitle: 'We gave agents boundaries and a chain of custody.',
        breakthroughDesc: 'Three engines - semantic reasoning, execution policy, context manager - working together. Agents operate within bounded decision spaces derived from source documentation. Every decision has a full context graph. Human overrides feed straight back into the knowledge flywheel.'
    }
];

const ArchitectureSection = () => (
    <section className="py-5" style={{background: '#fafbfc'}}>
        <Container>
            <div className="text-center mb-5">
                <div className="section-label">The Architecture</div>
                <h2>Three walls. Three breakthroughs.</h2>
                <p className="section-intro">
                    Built from the ground up around <strong>Nebulyx Cognition</strong> - our
                    deterministic, patent-pending language model - with <strong>Nebulyx AI Studio</strong> for
                    rapid prototyping and <strong>Nebulyx AgentDOG</strong> for governed agents on top.
                </p>
            </div>

            <div className="d-flex flex-column gap-4">
                {pairs.map((p, i) => (
                    <div key={i} className="approach-pair">
                        <div className="approach-pair-connector" style={{background: p.accent}}/>
                        <div className="approach-challenge">
                            <div className="approach-pair-badge approach-pair-badge-challenge">
                                <FontAwesomeIcon icon={faTriangleExclamation}/>
                                <span>The Challenge</span>
                            </div>
                            <h4 className="approach-pair-title">{p.challengeTitle}</h4>
                            <p className="approach-pair-desc">{p.challengeDesc}</p>
                        </div>
                        <div className="approach-pair-arrow">
                            <FontAwesomeIcon icon={faArrowRightLong}/>
                        </div>
                        <div className="approach-breakthrough">
                            <div className="approach-pair-badge"
                                 style={{
                                     background: `${p.accent}15`,
                                     color: p.accent
                                 }}>
                                <FontAwesomeIcon icon={faCircleCheck}/>
                                <span>The Breakthrough</span>
                            </div>
                            <h4 className="approach-pair-title">{p.breakthroughTitle}</h4>
                            <p className="approach-pair-desc">{p.breakthroughDesc}</p>
                        </div>
                    </div>
                ))}
            </div>
        </Container>
    </section>
);

export default ArchitectureSection;